export default function () {
    const contrastElement = document.querySelector('.accesibility__contrast');
    const fontSizeElement =  document.querySelector('.accesibility__font-size');
    if ( ! contrastElement || ! fontSizeElement ) {
        return;
    }
    contrastElement.addEventListener('click', function() {

        if ( this.classList.contains('var_contrast') ) {
            this.classList.remove('var_contrast');
            document.body.classList.remove('contrast_on');
            document.cookie = "contrast_on=false; path=/";
        } else {
            this.classList.add('var_contrast');
            document.body.classList.add('contrast_on');
            document.cookie = "contrast_on=true; path=/";
        }
    })

    fontSizeElement.addEventListener('click', function() { this.classList.toggle('var_open') })

    const fontSizeOptions = document.querySelectorAll('.accesibility__font-size li');

    fontSizeOptions.forEach(option => option.addEventListener('click', function() {
        fontSizeChanger(this.getAttribute('data-font-size'))
    }))

    function getCookie(name) {
        function escape(s) { return s.replace(/([.*+?\^$(){}|\[\]\/\\])/g, '\\$1'); }
        var match = document.cookie.match(RegExp('(?:^|;\\s*)' + escape(name) + '=([^;]*)'));
        return match ? match[1] : null;
    }

    const contrast = getCookie('contrast_on');

    if ( contrast === 'true' ) {
        contrastElement.classList.add('var_contrast');
        document.body.classList.add('contrast_on');
    }

    const fontSize = getCookie('fontsize');

    fontSizeChanger(fontSize)

    function setFontSize(className) {
        switch (className) {
            case 'fontsize-1':
                document.documentElement.style.fontSize = '1rem';
                break;
            case 'fontsize-1-1':
                document.documentElement.style.fontSize = '1.15rem';
                break;
            case 'fontsize-1-2':
                document.documentElement.style.fontSize = '1.25rem';
                break;
            default:
                document.documentElement.style.fontSize = '1rem';
                break;
        }
    }

    function fontSizeChanger(currentFontSizeCookie) {
        const fontSize = currentFontSizeCookie;
        const oldFontValue = getCookie('fontsize');
        let currentClassName = `fontsize-${fontSize}`;
        let oldClassName = `fontsize-${oldFontValue}`;
        fontSizeElement.classList.add('var_fontsize');

        document.body.classList.add(currentClassName);
        setFontSize(currentClassName);
        if ( oldFontValue !== fontSize ) {
            document.body.classList.remove(oldClassName);
        }
        document.cookie = `fontsize=${fontSize}; path=/`;
    }
}
